export default {
  // 新的上传
  // 根据URL获取文件名和后缀
  getFileNameAndSuffixByUrl(url) {
    if (!url) return {};
    // 把目录等去除
    let fullFileName = url.split('/').pop();
    // 把？号后面参数去除
    fullFileName = fullFileName ? fullFileName.split('?')[0] : '';

    const dotIndex = fullFileName.lastIndexOf('.');

    return {
      filename: fullFileName.substring(0, dotIndex),
      suffix: fullFileName.substring(dotIndex + 1).toLowerCase(),
    };
  },
  // 是否是pdf文件,data?: string, type: 'url' | 'suffix' | 'mine'
  isPdf(data, type = 'url') {
    if (!data) return false;
    if (type === 'url') {
      const suffix = this.getFileNameAndSuffixByUrl(data).suffix;
      if (!suffix) return false;
      return ['pdf'].indexOf(suffix.toLowerCase()) > -1;
    } else if (type === 'suffix') {
      return ['pdf'].indexOf(data) > -1;
    } else if (type === 'mine') {
      return ['application/pdf'].indexOf(data) > -1;
    }
    return false;
  },
  // 是否是图片文件,data?: string, type: 'url' | 'suffix' | 'mine'
  isImage(data, type = 'url') {
    if (!data) return false;
    if (type === 'url') {
      const suffix = this.getFileNameAndSuffixByUrl(data).suffix;
      if (!suffix) return false;
      return ['jpeg', 'png', 'jpg'].indexOf(suffix) > -1;
    } else if (type === 'suffix') {
      return ['jpeg', 'png', 'jpg'].indexOf(data) > -1;
    } else if (type === 'mine') {
      return ['image/jpeg', 'image/png', 'image/jpg'].indexOf(data) > -1;
    }
    return false;
  },
};
